export const globalConstants = {
    allRightsReserved: ". All rights reserved.",
    by: "by: ",
    calendarDateFormat: "MM/DD/YYYY",
    calendarDateTimeFormat: "MM/DD/YYYY hh:mm a",
    copyrights: "Photoflare",
    dark: "dark",
    eventGuestsListFileName: "EventGuestsList.xlsx",
    eventQrPrefix: "event-qr-",
    eventSubApiPath: "event/",
    eventUrlPath: "event?event=",
    from: "From",
    h1: "h1",
    h4: "h4",
    h6: "h6",
    headshotGuestsListFileName: "HeadshotGuestsList.xlsx",
    hi: "Hi,",
    inProgress: "IN PROGRESS",
    light: "light",
    logoAlt: "logo",
    maxRowsPerPage: "Max Rows Per Page",
    next: "Next",
    noData: "No Data to Show",
    ownerEmail: "support@selfieXmedia.com",
    photoflareDashboard: "Photoflare - Dashboard",
    photoTimestampFormat: "MM/DD/YYYY HH:mm",
    previous: " Previous",
    qrDownloadPrefix: "registration-qr-",
    registrationUrlPath: "register?event=",
    savingChanges: "Saving changes...",
    searchEvents: "Search Events",
    successMainColor: "success.main",
    textSecondaryColor: "text.secondary",
    theme: "theme",
    version: "v2.0",
    you: " (YOU)",
};
